<div class="container-fluid">
 <!-- This is for wider screen like laptop phone-->
  <div  class="row" id="main-container">

    <div class="col-sm-12 col-md-12">

    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="card shadow-sm mb-4">
          <div class="card-header d-flex justify-content-between align-items-center bg-purple text-white round-top-borders">
            <div class="row fullWidth">
              <div class="col-sm-12">
                <table width="100%">
                  <tr>
                    <td><h3 class="mb-0"><i class="fa fa-calendar" aria-hidden="true"></i>  Weekly Quiz</h3> </td>
                    <td>
                      <div class="quizTips">
                        <span class="badge bg-success">XP: + {{question?.experiencePoint}}</span> <i class="fa fa-question"></i>
                        <div class="quizTipsItem">
                          <table class="myaccount-menu-table">
                            <tr>
                             <td class="tip-item" >
                               <ul>
                                 <li>
                                  Every multiple-choice or coding quiz comes with experience points (XP).
                                   &nbsp;   &nbsp;
                                 </li>
                                 <li>
                                  The amount of XP awarded depends on the difficulty of the exercise.
                                  &nbsp;   &nbsp;
                                </li>

                                 <li>
                                  Earn XP to take part in our monthly prize draws!
                                  &nbsp;   &nbsp;
                                 </li>
                                  <li>
                                  You can only redeem XP points once per question.
                                   &nbsp;   &nbsp;
                                  </li>
                                 <li>
                                  See our Terms & Conditions for full details.
                                 </li>
                               </ul>

                            </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <div *ngIf="question != null">
                    <tr>
                      <td>
                        <h4 style="margin-bottom: 1px;">Level: &nbsp;{{getSkillLevelValue()}}</h4>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4 style="margin-top: 0px;">Subject: &nbsp;{{ subCategory}}</h4>
                      </td>
                    </tr>
                  </div>
                </table>
              </div>
            </div>

          </div>
          <p style="margin-bottom: 0px;"><mat-progress-bar mode="determinate" [value]="progressBarValue"></mat-progress-bar></p>
              <div class="card-body">

                <div class="row" *ngIf="!complete">
                  <h4 *ngIf="quizType === localQuestionType.Multiple_Choice_Quiz" style="margin-bottom: 1px;"><b>Multiple-Choice</b></h4>
                  <h4 *ngIf="quizType === localQuestionType.Coding_Quiz" style="margin-bottom: 1px;"><b> Coding Problem</b></h4>
                    <p>{{question?.content}}<p>
                </div>

              <div class="row" *ngIf="question === null && quizType === localQuestionType.Multiple_Choice_Quiz">
                  <h3>No multiple-choice quiz for this challenge. </h3>
              </div>
              <div class="row" *ngIf="question === null && quizType ===  localQuestionType.Coding_Quiz">
                <h3>No coding quiz for this challenge. </h3>
              </div>
                <div class="row" *ngIf="complete">
                  <div class="col-sm-2 col-md-2"></div>
                  <div class="col-sm-8 col-md-8">
                    <p> <i class="fa fa-clipboard-check"></i> You have successfully completed this exercise. Well done <i class="fa fa-thumbs-up"></i></p>
                  </div>
                  <div class="col-sm-2 col-md-2"></div>
                </div>

                 <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <form id="quizForm">
                                  <ng-template ngFor let-questionOption [ngForOf]="question?.options" let-i="index" *ngIf="!complete && question?.questionType == localQuestionType.Multiple_Choice_Quiz">

                                      <div class="form-check mb-2">
                                        <label class="quiz-option" (click)="selectOption(questionOption.content)" [class.selected]="selectedOption === questionOption.content">
                                          <input type="radio"
                                                name="option"
                                                [value]="questionOption.content"
                                                [(ngModel)]="selectedOption"
                                                [checked]="selectedOption === questionOption.content">
                                                <strong>{{ getOptionPrefix(i) }}.</strong> {{ questionOption.content }}
                                        </label>
                                      </div>
                                  </ng-template>
                              </form>
                            </div>
                </div>

                <div class="row" *ngIf="explanation != null && question?.questionType == localQuestionType.Multiple_Choice_Quiz" >
                       <div class="col-sm-12 col-md-12">
                          <div class="form-check mb-2">
                            <p class="quiz-option-correct"> Correct:&nbsp;  {{explanation}} &nbsp; <i class="fa fa-check text-blue"></i></p>
                          </div>
                       </div>
                </div>

                 <div class="row" *ngIf="!complete && question?.questionType == localQuestionType.Multiple_Choice_Quiz">
                      <div class="col-sm-12 col-md-12">
                        <div class="form-check mb-2">
                          <p class="quiz-option-error" *ngIf="errorMessage != null">
                            <i style="color: red; font-weight: bold;">X</i> &nbsp; {{errorMessage}}
                          </p>
                          <div class="row">
                            <p class="quiz-option-correct" *ngIf="successMessage != null">
                              {{successMessage}} &nbsp; <i class="fa fa-check text-blue"></i>
                            </p>
                          </div>
                        </div>
                      </div>
                   </div>

                <div class="row" *ngIf="!complete && question?.questionType == localQuestionType.Coding_Quiz" >
                  <div class="col-sm-12 col-md-12">
                    <textarea id="chat_message"  #chat_message name="chat_message" type="text" autocomplete="off"
                      placeholder="Type your code here..." [(ngModel)]="codeArea" minlength="1" maxlength="900" rows="10"
                      data-toggle="tooltip" title="Please enter between 1 and 900 characters. Don't alter method signature."></textarea>
                  </div>
                </div>
                <br/>
                <div class="row" *ngIf="!complete && question?.questionType == localQuestionType.Coding_Quiz">
                  <div class="col-sm-12 col-md-12">
                    <div class="form-check mb-2">
                      <p class="quiz-option-error" *ngIf="errorMessage != null">
                        <i style="color: red; font-weight: bold;">X</i> &nbsp; {{errorMessage}}
                      </p>
                        <p class="quiz-option-correct" *ngIf="successMessage != null">
                          {{successMessage}} &nbsp; <i class="fa fa-check text-blue"></i>
                        </p>
                    </div>
                  </div>
                </div>


                <div *ngIf="!complete &&  question?.questionType == localQuestionType.Coding_Quiz">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <p>Test cases... &nbsp;</p> <p *ngIf="this.successMessage"><i class="fa fa-check text-blue"></i></p>
                      </mat-panel-title>
                      <mat-panel-description>

                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <ul>
                      <li *ngFor="let testCase of question?.options[0].testcases">
                        <h3><b> {{testCase.description}} </b></h3>
                        <h3>
                          <span>Expected Input: </span>
                          <span *ngFor="let parameter of testCase.parameters">
                            <span>{{parameter.inputValue}} </span> <span>,</span>
                          </span>
                        </h3>
                        <h3>Expected Output: {{ testCase.expectedOutput}}</h3>
                      </li>
                    </ul>
                    <p *ngIf="articles.length <= 0">Sorry there is no suggested articles for this exercise.</p>

                  </mat-expansion-panel>
                </div>

                <div class="row" >
                  <div class="col-sm-6 col-md-8">
                    <button class="btn btn-primary m-1" *ngIf="!complete &&  question?.questionType == localQuestionType.Coding_Quiz" (click)="compileCode()">Compile & Run</button>
                    <mat-spinner *ngIf="showSpinnerCompileRequest" diameter="30"></mat-spinner>
                  </div>
                  <div class="col-sm-5 col-md-2">
                  </div>
                  <div class="col-sm-1 col-md-2">
                  </div>
                </div>

              </div>




            </div>
              <!-- <div *ngIf="!complete" class="fullWidth">
                <p> <i class="fa fa-bullhorn"></i> Want to level up? Log in to your account for more practice exercises!</p>
              </div> -->
            </div>
     </div>
    </div>
  </div>
</div>
